<template>
  <v-row>
    <v-col cols="12" md="8">
      <tableDebug
        :topicValue="arrayWithTopics"
        @delItem="deleteItem"
      ></tableDebug>
    </v-col>
    <v-col cols="12" md="4">
      <div>
        <div class="panel">
          <div class="panel-1">
            <publish @createPublish="setTopic"></publish>
          </div>
          <div class="panel-2">
            <subscribe @createSubscribe="setTopic"></subscribe>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import tableDebug from "./table";
import publish from "./publish";
import subscribe from "./subscribe";
import { eventBus } from "@/main.ts";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      arrayWithTopics: [],
    };
  },
  components: {
    tableDebug,
    publish,
    subscribe,
  },
  computed: {
    ...mapGetters(["isUserStaff"]),
  },
  mounted() {
    if (!this.isUserStaff)
      this.$router.push({ name: "home", query: { redirect: "home" } });
  },
  methods: {
    setTopic(topic) {
      if (!this.arrayWithTopics.includes(topic)) {
        this.arrayWithTopics.push(topic);
      }
    },
    deleteItem(item) {
      console.log("Item", item);
      this.arrayWithTopics = item;
      console.log("Array Topics", this.arrayWithTopics);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 359px) {
  div.panel {
    flex-direction: row;
    justify-content: center;
  }
}

@media screen and (min-width: 400px) and (max-width: 961px) {
  div.panel {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  div.panel-1 {
    width: 280px;
    display: inline-block;
  }
  div.panel-2 {
    width: 280px;
    display: inline-block;
  }
}
</style>